export default __webpack_public_path__ + "static/media/dg6.84e33f29.jpg";